/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { Button, Icon } from 'semantic-ui-react'
import EditModal from '../../commonComponent/editModal'
import DeleteModal from '../../deleteComponent/deleteModal'
import DeleteAxios from '../../axiosComponent/delete'
import FormikEditVendorType from './editVendorType'

function VendorTypeActionButton(props) {
    const [editModal, setEditModal] = useState(false)
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    // console.log('>>>', props.frameworkComponentWrapper.agGridReact.props.rowData)
    let handleEditClose = () => {
        setEditModal(false)
    }
    let handleClose = () => {
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)
        let id = props.data.id
        DeleteAxios({
            url: 'vendortype/delete',
            deleteItems: {
                vendorTypeId: id
            },
            deleted: (data) => {
                if (data && data.status === 1) {
                    setTimeout(() => {
                        setsuccess(false)
                        props.agGridReact.props.reload(true)
                    }, 500);
                }
            }
        })

    }
    let handleOpenEdit = (e) => {
        setEditModal(true)
    }
    let handleOpenDelete = (e) => {
        setopenBox(true)
    }
    return (
        <>
            <Button disabled={props.data && props.data.customerNo === 0 ? true : false} onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="edit" color="green" /></Button>
            <Button disabled={props.data && props.data.customerNo === 0 ? true : false} onClick={handleOpenDelete} basic size="mini" type="button" icon> <Icon name="trash" color="red" /></Button>
            <DeleteModal isloading={success} open={openBox} onClose={handleClose} handleDelete={handleDelete} />
            <EditModal size="mini" open={editModal} onClose={handleEditClose}>
                <FormikEditVendorType vendorType={props.data} getUpdate={props.agGridReact.props} handleClose={handleEditClose} />
            </EditModal>
        </>
    )
}

export default VendorTypeActionButton
